import React from "react";
import {useCallback, useEffect, useRef} from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

export const InfiniteScroll = ({onLoadMore, className, height = "96px"}) => {
    const loader = useRef(null);

    const handleObserver = useCallback((entries) => {
        const target = entries[0];
        if (target.isIntersecting) {
            onLoadMore && onLoadMore();
        }
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(handleObserver, {});
        if (loader.current) observer.observe(loader.current);
    }, [handleObserver]);

    return <div className={classNames("infinite-scroll", className)} ref={loader} style={{height}} />
}

InfiniteScroll.propTypes = {
    /**
     * Callback function when the InfiniteScroll element is reached (within scrollMargin)
     */
    onLoadMore: PropTypes.func,

    /**
     * Add custom classname
     */
    className: PropTypes.string,

    /**
     * Height of the component as css string. Defaults to '96px'
     */
    height: PropTypes.string

};
